import { render, staticRenderFns } from "./DataManageClass.vue?vue&type=template&id=2a3b848c&scoped=true&"
import script from "./DataManageClass.vue?vue&type=script&lang=js&"
export * from "./DataManageClass.vue?vue&type=script&lang=js&"
import style0 from "./DataManageClass.vue?vue&type=style&index=0&id=2a3b848c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3b848c",
  null
  
)

export default component.exports